import React, { createContext, useContext } from 'react';

interface CVContextType {
  isCVMode: boolean;
  phone: string | null;
}

const CVContext = createContext<CVContextType | undefined>(undefined);

export function CVProvider({ children, isCVMode, phone }: {
  children: React.ReactNode;
  isCVMode: boolean;
  phone: string | null;
}) {
  return <CVContext.Provider value={{ isCVMode, phone }}>{children}</CVContext.Provider>;
}

export function useCV() {
  const context = useContext(CVContext);
  if (context === undefined) {
    throw new Error('useCV must be used within CVProvider');
  }
  return context;
}
